export const GET_FORMATIVE_REPORTS_PERIODS = 'GET_FORMATIVE_REPORTS_PERIODS'
export const GET_FORMATIVE_REPORTS_PERIODS_SUCCESS = 'GET_FORMATIVE_REPORTS_PERIODS_SUCCESS'
export const GET_FORMATIVE_REPORTS_PERIODS_FAILED = 'GET_FORMATIVE_REPORTS_PERIODS_FAILED'
